import type { SerializableProductGameConfig } from '@texas42/app-model';
import { serializableToEngineConfig } from '@texas42/app-model';
import type { GameConfig } from '@texas42/game-runtime';

/** Product-config → engine-config mapper for persistence restore. */
export function toEngineGameConfig(config: SerializableProductGameConfig): GameConfig {
  return serializableToEngineConfig(config);
}

export function resolveReplaySeed(config: SerializableProductGameConfig): number {
  return config.shuffleSeed ?? 42_4242;
}
